import { MEDIA } from "@/styles/common";
import { Box, Button, Center, Grid, Text } from "@chakra-ui/react";
import { type IntroProps } from "./types";

export const Intro = ({ introGroup }: IntroProps) => {
    const { isMobile, isTablet } = MEDIA();

    return (
        <Center w="100vw" height="100vh" zIndex="9999" background="white">
            <Grid
                w="100%"
                h="100%"
                justifyContent="center"
                alignItems="center"
                gridTemplateColumns={!isTablet ? `repeat(${introGroup.length}, 1fr)` : "1fr"}
                gridTemplateRows={isTablet ? `repeat(${introGroup.length}, 1fr)` : "auto"}
            >
                {introGroup.map((group, index) => {
                    const isTestDomain = group.domain.includes("https://dst");
                    return (
                        <Center
                            h="100%"
                            flexDir="column"
                            key={group.co_id}
                            borderRight={!isMobile && index !== introGroup.length - 1 ? "1px solid #cbcbcb" : "none"}
                            borderBottom={isMobile && index !== introGroup.length - 1 ? "1px solid #cbcbcb" : "none"}
                            _hover={{ background: "#f5f3ef" }}
                            p={!isTablet ? "24px 16px" : "0"}
                        >
                            <Center
                                maxW={isTablet ? "768px" : "480px"}
                                w="100%"
                                flexDir="column"
                                rowGap="24px"
                                p={isTablet ? "24px 16px" : "0"}
                            >
                                <Box
                                    w="100%"
                                    h="80px"
                                    background={`url(${group.logo_URL})no-repeat center/contain`}
                                ></Box>
                                <Box
                                    w="100%"
                                    h={isTablet ? "224px" : "392px"}
                                    background={`url(${group.thumbnail_URL})no-repeat center/cover`}
                                    borderRadius="16px"
                                />
                                <Center flexDir="column" rowGap="12px">
                                    <Text
                                        fontSize={isTablet ? "16px" : "24px"}
                                        fontWeight="500"
                                        lineHeight="32px"
                                        color="#333"
                                    >
                                        {group.pension_name.kor}
                                    </Text>
                                    <Center
                                        flexDir="column"
                                        sx={{
                                            "& p": {
                                                fontSize: `${isTablet ? "14px" : "16px"}`,
                                                fontWeight: "300",
                                                lineHeight: `${isTablet ? "20px" : "28px"}`,
                                                color: "#000",
                                            },
                                        }}
                                    >
                                        <Text>{group.address}</Text>
                                        <Text>{group.tel}</Text>
                                    </Center>
                                </Center>
                                <Button
                                    w="160px"
                                    h="48px"
                                    borderRadius="24px"
                                    border="1px solid #333"
                                    onClick={() => {
                                        if (group.domain === "") return window.alert("연결된 주소가 없습니다");
                                        if (isTestDomain) return window.open(`${group.domain}`, "_blank");
                                        return window.open(`http://${group.domain}/?depth=home`, "_blank");
                                    }}
                                >
                                    <Text fontSize="24px" fontWeight="300" lineHeight="28px" color="#333">
                                        CLICK
                                    </Text>
                                </Button>
                            </Center>
                        </Center>
                    );
                })}
            </Grid>
        </Center>
    );
};
